import React from 'react'
import Link from 'gatsby-link'
import queryString from 'query-string'
import PageTitle from 'components/base/pageTitle'
import MainHelmet from 'components/base/mainHelmet'
import { navigateTo } from "gatsby-link"
import {applicationStyles, colors} from 'themes'

const styles = {
  second: {
    display: 'flex',
    flex: 1, 
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.white,
    padding: 45,
  },
  button: {
    margin: '20px',
    cursor: 'pointer',
    color: colors.darkBlue,
    backgroundColor: colors.white,
    padding: 20,
    borderRadius: 10,
    fontSize: '1.5em',
  }
}

const MoonlightingMarketingPage = ({ ...otherProps, keyword="doctor" }) => {
  const getDetails = pageData => {
    if (pageData.location && pageData.location.pathname) {
      const location = pageData.location.pathname.replace(`/${keyword}_moonlighting_jobs_in/`, '').replace('/', '')
      return location.split(',')  
    }
    return ['United States','']
  }
  const details = getDetails(otherProps)
  return (
    <div>
      <MainHelmet
        title={`Moonlighting ${keyword}  jobs in ${details[0]}, ${details[1]} | OnCallogy.com`}
      />
      <PageTitle title={`Moonlighting ${keyword} jobs in ${details[0]}, ${details[1]}`} />
      <div css={applicationStyles.mainTextContainer} className="blog-post">
      <p>
        OnCallogy is partnering with Hospitals, Urgent Cares, Physician Groups, and other facilities across the country.
        We are actively looking for moonlighting {keyword}s in {details[0]} to join our team.
      </p>
      <p>
        The process to become a moonlighting {keyword} in {details[1]} is actually suprisingly easy. Since OnCallogy aims to make moonlighting simple,
        we handle as many of the details of credentialing, calendaring, and malpractice insurance that we are able.
      </p>
      <p>
        We invite you to sign up today as a moonlighting {keyword} in {details[0]}, {details[1]}.
      </p>

      <p>
        If you happen to know of a facility that could benenfit by more streamlined moonlighting management, drop us a line!
      </p>

      </div>
      <div css={{...styles.second, backgroundColor: colors.darkBlue }}>
        <div css={styles.button} onClick={() => navigateTo('/beta')}>Join us Today!</div>
      </div>
    </div>
  )
}
  

export default MoonlightingMarketingPage



// WEBPACK FOOTER //
// ./src/pages/doctor_moonlighting_jobs_in.js